// School options for the chart form.
// Edit schools.txt (DB value, or "DB value|Display label") and regenerate with:
//   node src/components/ChartForm/buildSchools.js

/** @type {{ value: string, label: string }[]} */
export const schools = [
  {
    value: 'ACADEMY AT PALUMBO',
    label: 'Academy at Palumbo',
  },
  {
    value: 'ACHIEVE ACADEMY',
    label: 'Achieve Academy',
  },
  {
    value: 'ACHIEVE ACADEMY EAST',
    label: 'Achieve Academy East',
  },
  {
    value: 'AD PRIMA CHARTER SCHOOL',
    label: 'Ad Prima Charter School',
  },
  {
    value: 'ADAIRE, ALEXANDER SCHOOL',
    label: 'Adaire, Alexander School',
  },
  {
    value: 'AL-AQSA ISLAMIC SCHOOL',
    label: 'Al-Aqsa Islamic School',
  },
  {
    value: 'ALL SAINTS EPISCOPAL SCHOOL',
    label: 'All Saints Episcopal School',
  },
  {
    value: 'ALLEN, DR. ETHEL SCHOOL',
    label: 'Allen, Dr. Ethel School',
  },
  {
    value: 'ALLEN, ETHAN SCHOOL',
    label: 'Allen, Ethan School',
  },
  {
    value: 'ALLIANCE FOR PROGRESS CHARTER',
    label: 'Alliance for Progress Charter',
  },
  {
    value: 'ALLIANCE FOR PROGRESS CHARTER SCHOOL (ANNEX)',
    label: 'Alliance for Progress Charter School (Annex)',
  },
  {
    value: 'ALPHA HOUSE NURSERY & KINDERGARTEN',
    label: 'Alpha House Nursery & Kindergarten',
  },
  {
    value: 'AMY 5 AT JAMES MARTIN',
    label: 'AMY 5 at James Martin',
  },
  {
    value: 'AMY NORTHWEST',
    label: 'AMY Northwest',
  },
  {
    value: 'ANDERSON, ADD B. SCHOOL',
    label: 'Anderson, Add B. School',
  },
  {
    value: 'ANTHONY WAYNE ACADEMY',
    label: 'Anthony Wayne Academy',
  },
  {
    value: 'ANTONIA PANTOJA CHARTER SCHOOL',
    label: 'Antonia Pantoja Charter School',
  },
  {
    value: 'ARCHBISHOP RYAN HIGH SCHOOL',
    label: 'Archbishop Ryan High School',
  },
  {
    value: 'ARTS ACADEMY AT BENJAMIN RUSH',
    label: 'Arts Academy at Benjamin Rush',
  },
  {
    value: 'BACHE-MARTIN SCHOOL',
    label: 'Bache-Martin School',
  },
  {
    value: 'BALDI MIDDLE SCHOOL',
    label: 'Baldi Middle School',
  },
  {
    value: 'BARRY, JOHN ELEMENTARY SCHOOL',
    label: 'Barry, John Elementary School',
  },
  {
    value: 'BARTON SCHOOL',
    label: 'Barton School',
  },
  {
    value: 'BARTRAM, JOHN HIGH SCHOOL',
    label: 'Bartram, John High School',
  },
  {
    value: 'BEGINNINGS LEARNING CENTER',
    label: 'Beginnings Learning Center',
  },
  {
    value: 'BELMONT ACADEMY CHARTER SCHOOL',
    label: 'Belmont Academy Charter School',
  },
  {
    value: 'BELMONT CHARTER HIGH SCHOOL',
    label: 'Belmont Charter High School',
  },
  {
    value: 'BELMONT ELEMENTARY CHARTER',
    label: 'Belmont Elementary Charter',
  },
  {
    value: 'BETHEL BAPTIST ACADEMY',
    label: 'Bethel Baptist Academy',
  },
  {
    value: 'BETHUNE, MARY MCLEOD SCHOOL',
    label: 'Bethune, Mary McLeod School',
  },
  {
    value: 'BEULAH BAPTIST CHRISTIAN DAY SCHOOL',
    label: 'Beulah Baptist Christian Day School',
  },
  {
    value: 'BLAINE, JAMES G. SCHOOL',
    label: 'Blaine, James G. School',
  },
  {
    value: 'BLAIR CHRISTIAN ACADEMY & PRESCHOOL',
    label: 'Blair Christian Academy & Preschool',
  },
  {
    value: 'BLANKENBURG, RUDOLPH SCHOOL',
    label: 'Blankenburg, Rudolph School',
  },
  {
    value: 'BLESSED TRINITY REGIONAL CATHOLIC SCHOOL',
    label: 'Blessed Trinity Regional Catholic School',
  },
  {
    value: 'BODINE, WILLIAM W. HIGH SCHOOL',
    label: 'Bodine, William W. High School',
  },
  {
    value: 'BOYS LATIN OF PHILADELPHIA CHARTER',
    label: 'Boys Latin of Philadelphia Charter',
  },
  {
    value: 'BREGY, F. AMEDEE SCHOOL',
    label: 'Bregy, F. Amedee School',
  },
  {
    value: 'BRIDESBURG SCHOOL',
    label: 'Bridesburg School',
  },
  {
    value: 'BRIDGE WAY SCHOOL',
    label: 'Bridge Way School',
  },
  {
    value: 'BROWN, HENRY A. SCHOOL',
    label: 'Brown, Henry A. School',
  },
  {
    value: 'BROWN, JOSEPH H. SCHOOL',
    label: 'Brown, Joseph H. School',
  },
  {
    value: 'BRYANT, WILLIAM C. SCHOOL',
    label: 'Bryant, William C. School',
  },
  {
    value: 'BUILDING 21',
    label: 'Building 21',
  },
  {
    value: 'CALVARY CHRISTIAN ACADEMY',
    label: 'Calvary Christian Academy',
  },
  {
    value: 'CARNELL, LAURA H. SCHOOL',
    label: 'Carnell, Laura H. School',
  },
  {
    value: 'CASSIDY,LEWIS C ACADEMICS PLUS',
    label: 'Cassidy,lewis C Academics Plus',
  },
  {
    value: 'CASTOR GARDENS MIDDLE SCHOOL',
    label: 'Castor Gardens Middle School',
  },
  {
    value: 'CATHARINE, JOSEPH SCHOOL',
    label: 'Catharine, Joseph School',
  },
  {
    value: 'CAYUGA SCHOOL',
    label: 'Cayuga School',
  },
  {
    value: 'CB COMMUNITY SCHOOLS',
    label: 'CB Community Schools',
  },
  {
    value: 'CEDAR GROVE CHRISTIAN ACADEMY LOWER SCHOOL',
    label: 'Cedar Grove Christian Academy Lower School',
  },
  {
    value: 'CENTRAL HIGH SCHOOL',
    label: 'Central High School',
  },
  {
    value: 'CHESTERBROOK ACADEMY',
    label: 'Chesterbrook Academy',
  },
  {
    value: "CHILDREN'S HOUSE OF PHILADELPHIA",
    label: "Children's House of Philadelphia",
  },
  {
    value: 'CHILDS, GEORGE W. SCHOOL',
    label: 'Childs, George W. School',
  },
  {
    value: 'CHRIST THE KING SCHOOL',
    label: 'Christ the King School',
  },
  {
    value: 'CHRISTOPHER COLUMBUS CHARTER',
    label: 'Christopher Columbus Charter',
  },
  {
    value: 'CHRISTOPHER COLUMBUS CHARTER SCHOOL (ANNEX)',
    label: 'Christopher Columbus Charter School (Annex)',
  },
  {
    value: 'CITY SCHOOL AT FAIRMOUNT',
    label: 'City School at Fairmount',
  },
  {
    value: 'CLEMENTE, ROBERTO MIDDLE SCHOOL',
    label: 'Clemente, Roberto Middle School',
  },
  {
    value: 'COMEGYS, BENJAMIN B. SCHOOL',
    label: 'Comegys, Benjamin B. School',
  },
  {
    value: 'COMLY, WATSON SCHOOL',
    label: 'Comly, Watson School',
  },
  {
    value: 'COMMUNITY ACADEMY OF PHILADELPHIA',
    label: 'Community Academy of Philadelphia',
  },
  {
    value: 'COMMUNITY COUNCIL LEARNING ACADEMY',
    label: 'Community Council Learning Academy',
  },
  {
    value: 'COMMUNITY PARTNERSHIP SCHOOL',
    label: 'Community Partnership School',
  },
  {
    value: 'CONSTITUTION HIGH SCHOOL',
    label: 'Constitution High School',
  },
  {
    value: 'CONWELL, RUSSELL MIDDLE SCHOOL',
    label: 'Conwell, Russell Middle School',
  },
  {
    value: 'COOK-WISSAHICKON SCHOOL',
    label: 'Cook-Wissahickon School',
  },
  {
    value: 'COOKE, JAY ELEMENTARY SCHOOL',
    label: 'Cooke, Jay Elementary School',
  },
  {
    value: 'COPPIN, FANNY JACKSON SCHOOL',
    label: 'Coppin, Fanny Jackson School',
  },
  {
    value: 'CORNERSTONE CHRISTIAN ACADEMY',
    label: 'Cornerstone Christian Academy',
  },
  {
    value: 'CRAMP, WILLIAM SCHOOL',
    label: 'Cramp, William School',
  },
  {
    value: 'CREATIVE AND PERFORMING ARTS',
    label: 'Creative and Performing Arts',
  },
  {
    value: 'CREFELD SCHOOL',
    label: 'Crefeld School',
  },
  {
    value: 'CRISTO REY PHILADELPHIA HIGH SCHOOL',
    label: 'Cristo Rey Philadelphia High School',
  },
  {
    value: 'CROSSAN, KENNEDY C. SCHOOL',
    label: 'Crossan, Kennedy C. School',
  },
  {
    value: 'CROSSROADS @ HUNTING PARK',
    label: 'Crossroads @ Hunting Park',
  },
  {
    value: 'CROSSROADS ACCELERATED ACADEMY',
    label: 'Crossroads Accelerated Academy',
  },
  {
    value: 'DAY, ANNA B. SCHOOL',
    label: 'Day, Anna B. School',
  },
  {
    value: 'DE HOSTOS CHARTER SCHOOL',
    label: 'De Hostos Charter School',
  },
  {
    value: 'DEBURGOS, J. ELEMENTARY',
    label: 'Deburgos, J. Elementary',
  },
  {
    value: 'DECATUR, STEPHEN SCHOOL',
    label: 'Decatur, Stephen School',
  },
  {
    value: 'DEEP ROOTS CHARTER SCHOOL',
    label: 'Deep Roots Charter School',
  },
  {
    value: 'DELTA SCHOOL',
    label: 'Delta School',
  },
  {
    value: 'DEPAUL CATHOLIC SCHOOL',
    label: 'Depaul Catholic School',
  },
  {
    value: 'DICK, WILLIAM SCHOOL',
    label: 'Dick, William School',
  },
  {
    value: 'DISCOVERY CHARTER SCHOOL',
    label: 'Discovery Charter School',
  },
  {
    value: 'DISSTON, HAMILTON SCHOOL',
    label: 'Disston, Hamilton School',
  },
  {
    value: 'DOBBINS, MURRELL HIGH SCHOOL',
    label: 'Dobbins, Murrell High School',
  },
  {
    value: 'DOBSON, JAMES SCHOOL',
    label: 'Dobson, James School',
  },
  {
    value: 'DOUGLASS MASTERY CHARTER',
    label: 'Douglass Mastery Charter',
  },
  {
    value: 'DUCKREY, TANNER SCHOOL',
    label: 'Duckrey, Tanner School',
  },
  {
    value: 'DUNBAR, PAUL L. SCHOOL',
    label: 'Dunbar, Paul L. School',
  },
  {
    value: 'EDISON, THOMAS A. HIGH SCHOOL',
    label: 'Edison, Thomas A. High School',
  },
  {
    value: 'EDMONDS, FRANKLIN S. SCHOOL',
    label: 'Edmonds, Franklin S. School',
  },
  {
    value: 'EL CENTRO DE ESTUDIANTES',
    label: 'El Centro de Estudiantes',
  },
  {
    value: 'ELKIN, LEWIS SCHOOL',
    label: 'Elkin, Lewis School',
  },
  {
    value: 'ELLWOOD SCHOOL',
    label: 'Ellwood School',
  },
  {
    value: 'EMLEN, ELEANOR C. SCHOOL',
    label: 'Emlen, Eleanor C. School',
  },
  {
    value: 'ENGINEERING & SCIENCE HIGH',
    label: 'Engineering & Science High',
  },
  {
    value: 'ESPERANZA ACADEMY CHARTER',
    label: 'Esperanza Academy Charter',
  },
  {
    value: 'EXCEL ACADEMY CENTRAL',
    label: 'Excel Academy Central',
  },
  {
    value: 'EXCEL ACADEMY NORTH',
    label: 'Excel Academy North',
  },
  {
    value: 'EXCEL ACADEMY SOUTH',
    label: 'Excel Academy South',
  },
  {
    value: 'EXCEL MIDDLE YEARS ACADEMY',
    label: 'Excel Middle Years Academy',
  },
  {
    value: 'EXCELSIOR SCHOOL OF PHILADELPHIA',
    label: 'Excelsior School of Philadelphia',
  },
  {
    value: 'FARRELL, LOUIS H. SCHOOL',
    label: 'Farrell, Louis H. School',
  },
  {
    value: 'FATHER JUDGE HIGH SCHOOL',
    label: 'Father Judge High School',
  },
  {
    value: 'FELL, D. NEWLIN SCHOOL',
    label: 'Fell, D. Newlin School',
  },
  {
    value: 'FELS, SAMUEL HIGH SCHOOL',
    label: 'Fels, Samuel High School',
  },
  {
    value: 'FELTONVILLE ARTS & SCIENCES',
    label: 'Feltonville Arts & Sciences',
  },
  {
    value: 'FELTONVILLE INTERMEDIATE',
    label: 'Feltonville Intermediate',
  },
  {
    value: 'FINLETTER, THOMAS K. SCHOOL',
    label: 'Finletter, Thomas K. School',
  },
  {
    value: 'FIRST PHILADELPHIA CHARTER',
    label: 'First Philadelphia Charter',
  },
  {
    value: 'FITLER ACADEMICS PLUS',
    label: 'Fitler Academics Plus',
  },
  {
    value: 'FITZPATRICK, A. L. SCHOOL',
    label: 'Fitzpatrick, A. L. School',
  },
  {
    value: 'FOLK ARTS CULTURAL TREASURES',
    label: 'Folk Arts Cultural Treasures',
  },
  {
    value: 'FORREST, EDWIN SCHOOL',
    label: 'Forrest, Edwin School',
  },
  {
    value: 'FOX CHASE FARMS',
    label: 'Fox Chase Farms',
  },
  {
    value: 'FOX CHASE SCHOOL',
    label: 'Fox Chase School',
  },
  {
    value: 'FRANK, ANNE SCHOOL',
    label: 'Frank, Anne School',
  },
  {
    value: 'FRANKFORD FRIENDS SCHOOL',
    label: 'Frankford Friends School',
  },
  {
    value: 'FRANKFORD HIGH SCHOOL',
    label: 'Frankford High School',
  },
  {
    value: 'FRANKLIN HIGH SCHOOL EOP',
    label: 'Franklin High School EOP',
  },
  {
    value: 'FRANKLIN LEARNING CENTER',
    label: 'Franklin Learning Center',
  },
  {
    value: 'FRANKLIN TOWNE CHARTER SCHOOL',
    label: 'Franklin Towne Charter School',
  },
  {
    value: 'FRANKLIN TOWNE ELEMENTARY',
    label: 'Franklin Towne Elementary',
  },
  {
    value: 'FRANKLIN, BENJAMIN HIGH SCHOOL',
    label: 'Franklin, Benjamin High School',
  },
  {
    value: 'FRANKLIN, BENJAMIN SCHOOL',
    label: 'Franklin, Benjamin School',
  },
  {
    value: 'FREIRE CHARTER SCHOOL',
    label: 'Freire Charter School',
  },
  {
    value: 'FRIENDS SELECT SCHOOL',
    label: 'Friends Select School',
  },
  {
    value: 'FURNESS, HORACE HIGH SCHOOL',
    label: 'Furness, Horace High School',
  },
  {
    value: 'G.L.A. CHARTER @ HUEY',
    label: 'G.L.A. Charter @ Huey',
  },
  {
    value: 'GATEWAY TO COLLEGE',
    label: 'Gateway to College',
  },
  {
    value: 'GERMANTOWN FRIENDS SCHOOL',
    label: 'Germantown Friends School',
  },
  {
    value: 'GESU SCHOOL',
    label: 'Gesu School',
  },
  {
    value: 'GIDEON, EDWARD SCHOOL',
    label: 'Gideon, Edward School',
  },
  {
    value: 'GIRARD ACADEMIC MUSIC PROGRAM',
    label: 'Girard Academic Music Program',
  },
  {
    value: 'GIRARD COLLEGE',
    label: 'Girard College',
  },
  {
    value: 'GIRARD, STEPHEN SCHOOL',
    label: 'Girard, Stephen School',
  },
  {
    value: 'GIRLS, PHILA HIGH SCHOOL FOR',
    label: 'Girls, PHILA High School For',
  },
  {
    value: 'GLOBAL LEADERSHIP ACADEMY',
    label: 'Global Leadership Academy',
  },
  {
    value: 'GLORIA CASAREZ ELEMENTARY SCHOOL',
    label: 'Gloria Casarez Elementary School',
  },
  {
    value: 'GOMPERS, SAMUEL SCHOOL',
    label: 'Gompers, Samuel School',
  },
  {
    value: 'GREATER HOPE CHRISTIAN ACADEMY',
    label: 'Greater Hope Christian Academy',
  },
  {
    value: 'GREEN TREE SCHOOL',
    label: 'Green Tree School',
  },
  {
    value: 'GREEN WOODS CHARTER SCHOOL',
    label: 'Green Woods Charter School',
  },
  {
    value: 'GREENBERG, JOSEPH SCHOOL',
    label: 'Greenberg, Joseph School',
  },
  {
    value: 'GREENE STREET FRIENDS SCHOOL',
    label: 'Greene Street Friends School',
  },
  {
    value: 'GREENE TOWNE SCHOOL INC',
    label: 'Greene Towne School Inc.',
  },
  {
    value: 'GREENFIELD, ALBERT M. SCHOOL',
    label: 'Greenfield, Albert M. School',
  },
  {
    value: 'GUION S BLUFORD ELEMENTARY SCHOOL',
    label: 'Guion S Bluford Elementary School',
  },
  {
    value: 'HACKETT, HORATIO B. SCHOOL',
    label: 'Hackett, Horatio B. School',
  },
  {
    value: 'HAMILTON, ANDREW SCHOOL',
    label: 'Hamilton, Andrew School',
  },
  {
    value: 'HANCOCK DEMONSTRATION SCHOOL',
    label: 'Hancock Demonstration School',
  },
  {
    value: 'HARAMBEE INSTITUTE OF SCIENCE',
    label: 'Harambee Institute of Science',
  },
  {
    value: 'HARDING, WARREN G. MIDDLE SCHOOL',
    label: 'Harding, Warren G. Middle School',
  },
  {
    value: 'HARRINGTON, AVERY D. SCHOOL',
    label: 'Harrington, Avery D. School',
  },
  {
    value: 'HARTRANFT, JOHN F. SCHOOL',
    label: 'Hartranft, John F. School',
  },
  {
    value: 'HENRY, CHARLES W. SCHOOL',
    label: 'Henry, Charles W. School',
  },
  {
    value: 'HESTON, EDWARD SCHOOL',
    label: 'Heston, Edward School',
  },
  {
    value: 'HIGH ROAD SCHOOL OF PHILADELPHIA- GERMANTOWN',
    label: 'High Road School of Philadelphia- Germantown',
  },
  {
    value: 'HIGH SCHOOL OF THE FUTURE',
    label: 'High School of the Future',
  },
  {
    value: 'HILL-FREEDMAN WORLD ACADEMY',
    label: 'Hill-Freedman World Academy',
  },
  {
    value: 'HMS SCHOOL FOR CHILDREN W/CEREBRAL PALSY',
    label: 'HMS School for Children W/Cerebral Palsy',
  },
  {
    value: 'HOLME, THOMAS SCHOOL',
    label: 'Holme, Thomas School',
  },
  {
    value: 'HOLY CROSS SCHOOL',
    label: 'Holy Cross School',
  },
  {
    value: 'HOLY INNOCENTS SCHOOL',
    label: 'Holy Innocents School',
  },
  {
    value: 'HOLY REDEEMER SCHOOL',
    label: 'Holy Redeemer School',
  },
  {
    value: 'HOPE PARTNERSHIP FOR EDUCATION',
    label: 'Hope Partnership for Education',
  },
  {
    value: 'HOPKINSON, FRANCIS SCHOOL',
    label: 'Hopkinson, Francis School',
  },
  {
    value: 'HOUSTON, HENRY H. SCHOOL',
    label: 'Houston, Henry H. School',
  },
  {
    value: 'HOWE, JULIA WARD SCHOOL',
    label: 'Howe, Julia Ward School',
  },
  {
    value: 'HUNTER, WILLIAM H. SCHOOL',
    label: 'Hunter, William H. School',
  },
  {
    value: 'HUNTING PARK CHRISTIAN ACADEMY',
    label: 'Hunting Park Christian Academy',
  },
  {
    value: 'HYACINTH MONTESSORI',
    label: 'Hyacinth Montessori',
  },
  {
    value: 'IMHOTEP CHARTER SCHOOL',
    label: 'Imhotep Charter School',
  },
  {
    value: 'IMMACULATE HEART OF MARY SCHOOL',
    label: 'Immaculate Heart of Mary School',
  },
  {
    value: 'INDEPENDENCE CHARTER SCHOOL',
    label: 'Independence Charter School',
  },
  {
    value: 'INDEPENDENCE CHARTER WEST',
    label: 'Independence Charter West',
  },
  {
    value: 'INQUIRY CHARTER SCHOOL',
    label: 'Inquiry Charter School',
  },
  {
    value: 'INTERNATIONAL CHRISTIAN HIGH SCHOOL',
    label: 'International Christian High School',
  },
  {
    value: 'ISLAMIC EDUCATION SCHOOL',
    label: 'Islamic Education School',
  },
  {
    value: 'JENKS ACADEMY ARTS & SCIENCES',
    label: 'Jenks Academy Arts & Sciences',
  },
  {
    value: 'JENKS, ABRAM SCHOOL',
    label: 'Jenks, Abram School',
  },
  {
    value: 'JESUS IS THE WAY CHRISTIAN ACADEMY',
    label: 'Jesus Is the Way Christian Academy',
  },
  {
    value: 'JOHN B STETSON MIDDLE SCHOOL',
    label: 'John B Stetson Middle School',
  },
  {
    value: 'JOHN HANCOCK DEMONSTRATION MIDDLE SCHOOL- LABRUM CAMPUS',
    label: 'John Hancock Demonstration Middle School- Labrum Campus',
  },
  {
    value: 'JUBILEE SCHOOL',
    label: 'Jubilee School',
  },
  {
    value: 'JUNIATA PARK ACADEMY',
    label: 'Juniata Park Academy',
  },
  {
    value: 'K012 KIDS SCHOOL',
    label: 'K012 Kids School',
  },
  {
    value: 'KEARNY, GEN. PHILIP SCHOOL',
    label: 'Kearny, Gen. Philip School',
  },
  {
    value: 'KELLEY, WILLIAM D. SCHOOL',
    label: 'Kelley, William D. School',
  },
  {
    value: 'KELLY, JOHN B. SCHOOL',
    label: 'Kelly, John B. School',
  },
  {
    value: 'KENDERTON ELEMENTARY',
    label: 'Kenderton Elementary',
  },
  {
    value: 'KENSINGTON CAPA',
    label: 'Kensington CAPA',
  },
  {
    value: 'KENSINGTON HEALTH SCIENCES',
    label: 'Kensington Health Sciences',
  },
  {
    value: 'KENSINGTON HIGH SCHOOL',
    label: 'Kensington High School',
  },
  {
    value: 'KEY, FRANCIS SCOTT SCHOOL',
    label: 'Key, Francis Scott School',
  },
  {
    value: 'KEYSTONE ACADEMY CHARTER',
    label: 'Keystone Academy Charter',
  },
  {
    value: 'KING, MARTIN LUTHER HIGH SCHOOL',
    label: 'King, Martin Luther High School',
  },
  {
    value: 'KIPP DUBOIS CHARTER SCHOOL',
    label: 'KIPP Dubois Charter School',
  },
  {
    value: 'KIPP NORTH PHILADELPHIA CHARTER SCHOOL',
    label: 'KIPP North Philadelphia Charter School',
  },
  {
    value: 'KIPP PHILADELPHIA ELEMENTARY ACADEMY',
    label: 'KIPP Philadelphia Elementary Academy',
  },
  {
    value: 'KIPP PHILADELPHIA OCTAVIUS CATTO ELEMENTARY',
    label: 'KIPP Philadelphia Octavius Catto Elementary',
  },
  {
    value: 'KIPP PHILADELPHIA PREPARATORY ACADEMY',
    label: 'KIPP Philadelphia Preparatory Academy',
  },
  {
    value: 'KIPP WEST PHILA CHARTER SCHOOL',
    label: 'KIPP West PHILA Charter School',
  },
  {
    value: 'KIPP WEST PHILADELPHIA PREPARATORY',
    label: 'KIPP West Philadelphia Preparatory',
  },
  {
    value: 'KIRKBRIDE, ELIZA B. SCHOOL',
    label: 'Kirkbride, Eliza B. School',
  },
  {
    value: "LAB SCH OF COMMUNICAT'N & LANG",
    label: "Lab Sch. of Communicat'n & LANG",
  },
  {
    value: "LAB SCH OF COMMUNICAT'N & LANG (EAST FALLS CAMPUS)",
    label: "Lab Sch. of Communicat'n & LANG (East Falls Campus)",
  },
  {
    value: 'LAMBERTON,ROBERT E ELEMENTARY',
    label: 'Lamberton,robert E Elementary',
  },
  {
    value: 'LANKENAU HIGH SCHOOL',
    label: 'Lankenau High School',
  },
  {
    value: 'LASALLE ACADEMY',
    label: 'La Salle Academy',
  },
  {
    value: 'LAWTON, HENRY W. SCHOOL',
    label: 'Lawton, Henry W. School',
  },
  {
    value: 'LEA, HENRY C.',
    label: 'Lea, Henry C.',
  },
  {
    value: 'LIGUORI ACADEMY',
    label: 'Liguori Academy',
  },
  {
    value: 'LIGUORI ACADEMY-FORTIS',
    label: 'Liguori Academy-Fortis',
  },
  {
    value: 'LINCOLN, ABRAHAM HIGH SCHOOL',
    label: 'Lincoln, Abraham High School',
  },
  {
    value: 'LINDLEY ACADEMY CHARTER @ BIRNEY',
    label: 'Lindley Academy Charter @ Birney',
  },
  {
    value: 'LINGELBACH, ANNA L. SCHOOL',
    label: 'Lingelbach, Anna L. School',
  },
  {
    value: 'LITTLE CITY MONTESSORI',
    label: 'Little City Montessori',
  },
  {
    value: 'LITTLE FLOWER CATHOLIC SCHOOL',
    label: 'Little Flower Catholic School',
  },
  {
    value: 'LOCKE, ALAIN SCHOOL',
    label: 'Locke, Alain School',
  },
  {
    value: 'LOESCHE, WILLIAM H. SCHOOL',
    label: 'Loesche, William H. School',
  },
  {
    value: 'LOGAN HOPE SCHOOL',
    label: 'Logan Hope School',
  },
  {
    value: 'LOGAN, JAMES SCHOOL',
    label: 'Logan, James School',
  },
  {
    value: 'LONGSTRETH, WILLIAM C. SCHOOL',
    label: 'Longstreth, William C. School',
  },
  {
    value: 'LOTUS ACADEMY',
    label: 'Lotus Academy',
  },
  {
    value: 'LOWELL, JAMES R. SCHOOL',
    label: 'Lowell, James R. School',
  },
  {
    value: 'LUDLOW, JAMES R. SCHOOL',
    label: 'Ludlow, James R. School',
  },
  {
    value: 'MARIAN ANDERSON NEIGHBORHOOD ACADEMY',
    label: 'Marian Anderson Neighborhood Academy',
  },
  {
    value: 'MARIANA BRACETTI ACADEMY',
    label: 'Mariana Bracetti Academy',
  },
  {
    value: 'MARITIME ACADEMY CHARTER',
    label: 'Maritime Academy Charter',
  },
  {
    value: 'MARITIME ACADEMY CHARTER SCHOOL (MACS)',
    label: 'Maritime Academy Charter School (MACS)',
  },
  {
    value: 'MARSHALL, JOHN SCHOOL',
    label: 'Marshall, John School',
  },
  {
    value: 'MARSHALL, THURGOOD SCHOOL',
    label: 'Marshall, Thurgood School',
  },
  {
    value: 'MAST COMMUNITY CHARTER II',
    label: 'MAST Community Charter II',
  },
  {
    value: 'MAST III CHARTER SCHOOL',
    label: 'MAST III Charter School',
  },
  {
    value: 'MASTBAUM, JULES E. HIGH SCHOOL',
    label: 'Mastbaum, Jules E. High School',
  },
  {
    value: 'MASTERMAN,JULIA R. HIGH SCHOOL',
    label: 'Masterman,julia R. High School',
  },
  {
    value: 'MASTERY CHARTER @ CLEVELAND',
    label: 'Mastery Charter @ Cleveland',
  },
  {
    value: 'MASTERY CHARTER @ CLYMER',
    label: 'Mastery Charter @ Clymer',
  },
  {
    value: 'MASTERY CHARTER @ GRATZ HIGH',
    label: 'Mastery Charter @ Gratz High',
  },
  {
    value: 'MASTERY CHARTER @ HARRITY',
    label: 'Mastery Charter @ Harrity',
  },
  {
    value: 'MASTERY CHARTER @ MANN',
    label: 'Mastery Charter @ Mann',
  },
  {
    value: 'MASTERY CHARTER @ PASTORIUS',
    label: 'Mastery Charter @ Pastorius',
  },
  {
    value: 'MASTERY CHARTER @ PICKETT',
    label: 'Mastery Charter @ Pickett',
  },
  {
    value: 'MASTERY CHARTER @ SMEDLEY',
    label: 'Mastery Charter @ Smedley',
  },
  {
    value: 'MASTERY CHARTER @ WISTER',
    label: 'Mastery Charter @ Wister',
  },
  {
    value: 'MASTERY CHARTER AT HARDY WILLIAMS',
    label: 'Mastery Charter at Hardy Williams',
  },
  {
    value: 'MASTERY CHARTER-LENFEST CAMPUS',
    label: 'Mastery Charter-Lenfest Campus',
  },
  {
    value: 'MASTERY CHARTER-SHOEMAKER',
    label: 'Mastery Charter-Shoemaker',
  },
  {
    value: 'MASTERY CHARTER-THOMAS CAMPUS',
    label: 'Mastery Charter-Thomas Campus',
  },
  {
    value: 'MASTERY PREP ELEMENTARY CHARTER SCHOOL',
    label: 'Mastery Prep Elementary Charter School',
  },
  {
    value: 'MASTERY SCHOOL THOMAS CAMPUS',
    label: 'Mastery School Thomas Campus',
  },
  {
    value: 'MATERNITY BVM SCHOOL',
    label: 'Maternity BVM School',
  },
  {
    value: 'MATH, SCIENCE AND TECHNOLOGY',
    label: 'Math, Science and Technology',
  },
  {
    value: 'MATHEMATICS, SCIENCE AND TECHNOLOGY COMMUNITY CHARTER SCHOOL II',
    label: 'Mathematics, Science and Technology Community Charter School II',
  },
  {
    value: 'MAYFAIR SCHOOL',
    label: 'Mayfair School',
  },
  {
    value: 'MC CALL, GEN. GEORGE A. SCHOOL',
    label: 'Mc Call, Gen. George A. School',
  },
  {
    value: 'MC CLURE, ALEXANDER K. SCHOOL',
    label: 'Mc Clure, Alexander K. School',
  },
  {
    value: 'MC MICHAEL, MORTON SCHOOL',
    label: 'Mc Michael, Morton School',
  },
  {
    value: 'MCCLOSKEY, JOHN F. SCHOOL',
    label: 'McCloskey John F. School',
  },
  {
    value: 'MCDANIEL, DELAPLAINE SCHOOL',
    label: 'McDaniel Delaplaine School',
  },
  {
    value: 'MCKINLEY, WILLIAM SCHOOL',
    label: 'McKinley William School',
  },
  {
    value: 'MEADE, GEN. GEORGE G. SCHOOL',
    label: 'Meade, Gen. George G. School',
  },
  {
    value: 'MEMPHIS ST. CHARTER @ JP JONES',
    label: 'Memphis St. Charter @ JP Jones',
  },
  {
    value: 'MERCY CAREER AND TECHNICAL HIGH SCHOOL',
    label: 'Mercy Career and Technical High School',
  },
  {
    value: 'MEREDITH, WILLIAM M. SCHOOL',
    label: 'Meredith, William M. School',
  },
  {
    value: 'METHODIST SERVICES FOR CHILDREN AND FAMILIES',
    label: 'Methodist Services for Children and Families',
  },
  {
    value: 'MIFFLIN, THOMAS SCHOOL',
    label: 'Mifflin, Thomas School',
  },
  {
    value: 'MILL CREEK SCHOOL',
    label: 'Mill Creek School',
  },
  {
    value: 'MITCHELL ELEMENTARY SCHOOL',
    label: 'Mitchell Elementary School',
  },
  {
    value: 'MOFFET, JOHN SCHOOL',
    label: 'Moffet, John School',
  },
  {
    value: 'MOORE, J. HAMPTON SCHOOL',
    label: 'Moore, J. Hampton School',
  },
  {
    value: 'MORRIS, ROBERT SCHOOL',
    label: 'Morris, Robert School',
  },
  {
    value: 'MORRISON, ANDREW J. SCHOOL',
    label: 'Morrison, Andrew J. School',
  },
  {
    value: 'MORTON, THOMAS G. SCHOOL',
    label: 'Morton, Thomas G. School',
  },
  {
    value: 'MOTHER DIVINE GRACE SCHOOL',
    label: 'Mother Divine Grace School',
  },
  {
    value: 'MOTIVATION HIGH SCHOOL',
    label: 'Motivation High School',
  },
  {
    value: 'MULTI-CULTURAL ACADEMY',
    label: 'Multi-Cultural Academy',
  },
  {
    value: 'MUNOZ-MARIN, HON LUIS SCHOOL',
    label: 'Munoz-Marin, Hon Luis School',
  },
  {
    value: 'MYA-MIDDLE YEARS ALTERNATIVE',
    label: 'MYA-Middle Years Alternative',
  },
  {
    value: 'NAZARETH ACADEMY GRADE SCHOOL',
    label: 'Nazareth Academy Grade School',
  },
  {
    value: 'NAZARETH ACADEMY HIGH SCHOOL',
    label: 'Nazareth Academy High School',
  },
  {
    value: 'NEBINGER, GEORGE W. SCHOOL',
    label: 'Nebinger, George W. School',
  },
  {
    value: 'NEW FOUNDATIONS CHARTER SCHOOL',
    label: 'New Foundations Charter School',
  },
  {
    value: 'NEW LIFE ALTERNATIVES CHRISTIAN ACADEMY',
    label: 'New Life Alternatives Christian Academy',
  },
  {
    value: 'NEW MEDINA LEARNING INSTITUTE',
    label: 'New Medina Learning Institute',
  },
  {
    value: 'NEW OAKS ACADEMY',
    label: 'New Oaks Academy',
  },
  {
    value: 'NORTHEAST COMMUNITY PROPEL ACADEMY',
    label: 'Northeast Community Propel Academy',
  },
  {
    value: 'NORTHEAST HIGH SCHOOL',
    label: 'Northeast High School',
  },
  {
    value: 'NORTHEAST HIGH SCHOOL EOP',
    label: 'Northeast High School EOP',
  },
  {
    value: 'NORTHWOOD CHARTER SCHOOL',
    label: 'Northwood Charter School',
  },
  {
    value: 'NORWOOD FONTBONNE ACADEMY',
    label: 'Norwood Fontbonne Academy',
  },
  {
    value: 'OIC CADI',
    label: 'OIC CADI',
  },
  {
    value: 'OLNEY CHRISTIAN SCHOOL',
    label: 'Olney Christian School',
  },
  {
    value: 'OLNEY ELEMENTARY SCHOOL',
    label: 'Olney Elementary School',
  },
  {
    value: 'OLNEY HIGH SCHOOL',
    label: 'Olney High School',
  },
  {
    value: 'ONE BRIGHT RAY MANSION',
    label: 'One Bright Ray Mansion',
  },
  {
    value: 'ONE BRIGHT RAY MANSION EVENING',
    label: 'One Bright Ray Mansion Evening',
  },
  {
    value: 'ONE BRIGHT RAY-ELMWOOD CAMPUS',
    label: 'One Bright Ray-Elmwood Campus',
  },
  {
    value: 'ONE BRIGHT RAY-FAIRHILL CAMPUS',
    label: 'One Bright Ray-Fairhill Campus',
  },
  {
    value: 'ONE BRIGHT RAY-SIMPSON CAMPUS',
    label: 'One Bright Ray-Simpson Campus',
  },
  {
    value: 'OUR LADY OF CALVARY SCHOOL',
    label: 'Our Lady of Calvary School',
  },
  {
    value: 'OUR LADY OF HOPE REGIONAL CATHOLIC SCHOOL',
    label: 'Our Lady of Hope Regional Catholic School',
  },
  {
    value: 'OUR LADY OF PORT RICHMOND SCHOOL',
    label: 'Our Lady of Port Richmond School',
  },
  {
    value: 'OUR MOTHER OF CONSOLATION',
    label: 'Our Mother of Consolation',
  },
  {
    value: 'OUR MOTHER OF SORROWS/ST IGNATIUS OF LOYOLA SCHOOL',
    label: 'Our Mother of Sorrows/St. Ignatius of Loyola School',
  },
  {
    value: 'OVERBROOK EDUCATIONAL CENTER',
    label: 'Overbrook Educational Center',
  },
  {
    value: 'OVERBROOK ELEMENTARY SCHOOL',
    label: 'Overbrook Elementary School',
  },
  {
    value: 'OVERBROOK HIGH SCHOOL',
    label: 'Overbrook High School',
  },
  {
    value: 'OVERBROOK SCHOOL FOR BLIND',
    label: 'Overbrook School for Blind',
  },
  {
    value: 'PAN AMERICAN ACADEMY CHARTER',
    label: 'Pan American Academy Charter',
  },
  {
    value: 'PARKWAY CENTER CITY MIDDLE COLLEGE HIGH SCHOOL',
    label: 'Parkway Center City Middle College High School',
  },
  {
    value: 'PARKWAY WEST HIGH SCHOOL',
    label: 'Parkway West High School',
  },
  {
    value: 'PARKWAY-NORTHWEST HIGH SCHOOL',
    label: 'Parkway-Northwest High School',
  },
  {
    value: 'PATTERSON, JOHN M. SCHOOL',
    label: 'Patterson, John M. School',
  },
  {
    value: 'PEIRCE, THOMAS M. SCHOOL',
    label: 'Peirce, Thomas M. School',
  },
  {
    value: 'PENN ALEXANDER SCHOOL',
    label: 'Penn Alexander School',
  },
  {
    value: 'PENN TREATY HIGH SCHOOL',
    label: 'Penn Treaty High School',
  },
  {
    value: 'PENNELL, JOSEPH ELEMENTARY',
    label: 'Pennell, Joseph Elementary',
  },
  {
    value: 'PENNSYLVANIA SCHOOL FOR THE DEAF',
    label: 'Pennsylvania School for the Deaf',
  },
  {
    value: 'PENNYPACK HOUSE SCHOOL',
    label: 'Pennypack House School',
  },
  {
    value: 'PENNYPACKER, SAMUEL SCHOOL',
    label: 'Pennypacker, Samuel School',
  },
  {
    value: 'PENROSE SCHOOL',
    label: 'Penrose School',
  },
  {
    value: 'PEOPLE FOR PEOPLE',
    label: 'People for People',
  },
  {
    value: 'PHILADELPHIA ACADEMY',
    label: 'Philadelphia Academy',
  },
  {
    value: 'PHILADELPHIA ACADEMY CHARTER SCHOOL (ANNEX)',
    label: 'Philadelphia Academy Charter School (Annex)',
  },
  {
    value: 'PHILADELPHIA CHARTER FOR ARTS',
    label: 'Philadelphia Charter for Arts',
  },
  {
    value: 'PHILADELPHIA CLASSICAL SCHOOL',
    label: 'Philadelphia Classical School',
  },
  {
    value: 'PHILADELPHIA CONTINUATION ACADEMY',
    label: 'Philadelphia Continuation Academy',
  },
  {
    value: 'PHILADELPHIA ELECTRICAL AND TECHNOLOGY CHARTER SCHOOL',
    label: 'Philadelphia Electrical and Technology Charter School',
  },
  {
    value: 'PHILADELPHIA FREE SCHOOL',
    label: 'Philadelphia Free School',
  },
  {
    value: 'PHILADELPHIA HEBREW PUBLIC CHARTER SCHOOL',
    label: 'Philadelphia Hebrew Public Charter School',
  },
  {
    value: 'PHILADELPHIA JUVENILE JUSTICE SERVICES CENTER',
    label: 'Philadelphia Juvenile Justice Services Center',
  },
  {
    value: 'PHILADELPHIA LEARNING ACADEMY-NORTH',
    label: 'Philadelphia Learning Academy-North',
  },
  {
    value: 'PHILADELPHIA LEARNING ACADEMY-WEST',
    label: 'Philadelphia Learning Academy-West',
  },
  {
    value: 'PHILADELPHIA MILITARY ACADEMY',
    label: 'Philadelphia Military Academy',
  },
  {
    value: 'PHILADELPHIA MONTESSORI',
    label: 'Philadelphia Montessori',
  },
  {
    value: 'PHILADELPHIA PERFORMING ARTS CHARTER SCHOOL',
    label: 'Philadelphia Performing Arts Charter School',
  },
  {
    value: 'PHILADELPHIA PERFORMING ARTS CHARTER: STRING THEORY (E. CAMPUS)',
    label: 'Philadelphia Performing Arts Charter: String Theory (E. Campus)',
  },
  {
    value: 'PHILADELPHIA PERFORMING ARTS-BROAD ST',
    label: 'Philadelphia Performing Arts-Broad St.',
  },
  {
    value: 'PHILADELPHIA SCHOOL',
    label: 'Philadelphia School',
  },
  {
    value: 'PHILADELPHIA VIRTUAL ACADEMY',
    label: 'Philadelphia Virtual Academy',
  },
  {
    value: 'PHILLY AGILE LEARNING COMMUNITY SCHOOL',
    label: 'Philly Agile Learning Community School',
  },
  {
    value: 'POINCIANA MONTESSORI',
    label: 'Poinciana Montessori',
  },
  {
    value: 'POLITZ HEBREW ACADEMY',
    label: 'Politz Hebrew Academy',
  },
  {
    value: 'POLLOCK, ROBERT B. SCHOOL',
    label: 'Pollock, Robert B. School',
  },
  {
    value: 'POTTER-THOMAS SCHOOL',
    label: 'Potter-Thomas School',
  },
  {
    value: 'POWEL, SAMUEL SCHOOL',
    label: 'Powel, Samuel School',
  },
  {
    value: 'PREPARATORY CHARTER SCHOOL',
    label: 'Preparatory Charter School',
  },
  {
    value: 'PRINCE HALL SCHOOL',
    label: 'Prince Hall School',
  },
  {
    value: 'PRODIGY LEARNING CENTERS',
    label: 'Prodigy Learning Centers',
  },
  {
    value: 'QUADRAT ACADEMY',
    label: 'Quadrat Academy',
  },
  {
    value: 'QUBA INSTITUTE OF ARABIC & ISLAMIC STUDIES',
    label: 'Quba Institute of Arabic & Islamic Studies',
  },
  {
    value: 'RANDOLPH TECHNICAL HIGH SCHOOL',
    label: 'Randolph Technical High School',
  },
  {
    value: 'RE-ENGAGEMENT CENTER',
    label: 'Re-Engagement Center',
  },
  {
    value: 'RED LION ELEMENTARY SCHOOL',
    label: 'Red Lion Elementary School',
  },
  {
    value: 'RESURRECTION REGIONAL CATHOLIC SCHOOL',
    label: 'Resurrection Regional Catholic School',
  },
  {
    value: 'REVOLUTION SCHOOL',
    label: 'Revolution School',
  },
  {
    value: 'RHAWNHURST SCHOOL',
    label: 'Rhawnhurst School',
  },
  {
    value: 'RHOADS, JAMES SCHOOL',
    label: 'Rhoads, James School',
  },
  {
    value: 'RHODES ELEMENTARY SCHOOL',
    label: 'Rhodes Elementary School',
  },
  {
    value: 'RICHARD ALLEN PREPARATORY',
    label: 'Richard Allen Preparatory',
  },
  {
    value: 'RICHMOND SCHOOL',
    label: 'Richmond School',
  },
  {
    value: 'ROBESON, PAUL HIGH SCHOOL',
    label: 'Robeson, Paul High School',
  },
  {
    value: 'ROMAN CATHOLIC HIGH SCHOOL',
    label: 'Roman Catholic High School',
  },
  {
    value: 'ROOSEVELT ELEMENTARY SCHOOL',
    label: 'Roosevelt Elementary School',
  },
  {
    value: 'ROWEN, WILLIAM SCHOOL',
    label: 'Rowen, William School',
  },
  {
    value: 'ROXBOROUGH CHRISTIAN SCHOOL',
    label: 'Roxborough Christian School',
  },
  {
    value: 'ROXBOROUGH HIGH SCHOOL',
    label: 'Roxborough High School',
  },
  {
    value: 'RUSSELL BYERS CHARTER SCHOOL',
    label: 'Russell Byers Charter School',
  },
  {
    value: 'SAINT LUCY SCHOOL FOR THE VISUALLY IMPAIRED',
    label: 'Saint Lucy School for the Visually Impaired',
  },
  {
    value: 'SAINTS TABERNACLE DAY SCHOOL',
    label: 'Saints Tabernacle Day School',
  },
  {
    value: 'SANKOFA FREEDOM ACADEMY',
    label: 'Sankofa Freedom Academy',
  },
  {
    value: 'SAUL, WALTER B. HIGH SCHOOL',
    label: 'Saul, Walter B. High School',
  },
  {
    value: 'SAYRE, WILLIAM L. HIGH SCHOOL',
    label: 'Sayre, William L. High School',
  },
  {
    value: 'SCIENCE LEADERSHIP ACADEMY',
    label: 'Science Leadership Academy',
  },
  {
    value: 'SCIENCE LEADERSHIP ACADEMY AT BEEBER',
    label: 'Science Leadership Academy at Beeber',
  },
  {
    value: 'SCIENCE LEADERSHIP ACADEMY MIDDLE SCHOOL',
    label: 'Science Leadership Academy Middle School',
  },
  {
    value: 'SHAARE SHAMAYIM-BETH JUDAH KINDERGARTEN',
    label: 'Shaare Shamayim-Beth Judah Kindergarten',
  },
  {
    value: 'SHARSWOOD, GEORGE SCHOOL',
    label: 'Sharswood, George School',
  },
  {
    value: 'SHAWMONT SCHOOL',
    label: 'Shawmont School',
  },
  {
    value: 'SHEPPARD, ISAAC A. SCHOOL',
    label: 'Sheppard, Isaac A. School',
  },
  {
    value: 'SMART CENTER ACADEMY',
    label: 'Smart Center Academy',
  },
  {
    value: 'SOLIS-COHEN, SOLOMON SCHOOL',
    label: 'Solis-Cohen, Solomon School',
  },
  {
    value: 'SOPHIA ACADEMY',
    label: 'Sophia Academy',
  },
  {
    value: 'SOUTH PHILADELPHIA HIGH SCHOOL',
    label: 'South Philadelphia High School',
  },
  {
    value: 'SOUTH PHILADELPHIA HIGH SCHOOL EOP',
    label: 'South Philadelphia High School EOP',
  },
  {
    value: 'SOUTHWARK SCHOOL',
    label: 'Southwark School',
  },
  {
    value: 'SOUTHWEST LEADERSHIP ACADEMY',
    label: 'Southwest Leadership Academy',
  },
  {
    value: 'SPRING GARDEN ACADEMY - TIOGA',
    label: 'Spring Garden Academy - Tioga',
  },
  {
    value: 'SPRING GARDEN SCHOOL',
    label: 'Spring Garden School',
  },
  {
    value: 'SPRINGSIDE CHESTNUT HILL ACADEMY',
    label: 'Springside Chestnut Hill Academy',
  },
  {
    value: 'SPRUANCE, GILBERT SCHOOL',
    label: 'Spruance, Gilbert School',
  },
  {
    value: 'SS JOHN NEUMANN AND MARIA GORETTI CATHOLIC HIGH SCHOOL',
    label: 'SS John Neumann and Maria Goretti Catholic High School',
  },
  {
    value: 'ST ANSELM ELEMENTARY SCHOOL',
    label: 'St. Anselm Elementary School',
  },
  {
    value: 'ST ANTHONY OF PADUA REGIONAL CATHOLIC SCHOOL',
    label: 'St. Anthony of Padua Regional Catholic School',
  },
  {
    value: 'ST ATHANASIUS IMMACULATE CONCEPTION SCHOOL',
    label: 'St. Athanasius Immaculate Conception School',
  },
  {
    value: 'ST BARNABAS CATHOLIC SCHOOL',
    label: 'St. Barnabas Catholic School',
  },
  {
    value: 'ST CECILIA SCHOOL',
    label: 'St. Cecilia School',
  },
  {
    value: 'ST CHRISTOPHER SCHOOL',
    label: 'St. Christopher School',
  },
  {
    value: 'ST DOMINIC SCHOOL',
    label: 'St. Dominic School',
  },
  {
    value: 'ST FRANCES CABRINI REGIONAL CATHOLIC SCHOOL',
    label: 'St. Frances Cabrini Regional Catholic School',
  },
  {
    value: 'ST FRANCIS DESALES SCHOOL',
    label: 'St. Francis Desales School',
  },
  {
    value: 'ST FRANCIS XAVIER SCHOOL',
    label: 'St. Francis Xavier School',
  },
  {
    value: 'ST GEORGE SCHOOL',
    label: 'St. George School',
  },
  {
    value: 'ST HELENA INCARNATION REGIONAL CATHOLIC SCHOOL',
    label: 'St. Helena Incarnation Regional Catholic School',
  },
  {
    value: 'ST HUBERTS CATHOLIC HIGH SCHOOL',
    label: 'St. Huberts Catholic High School',
  },
  {
    value: 'ST JAMES SCHOOL',
    label: 'St. James School',
  },
  {
    value: 'ST JEROME SCHOOL',
    label: 'St. Jerome School',
  },
  {
    value: "ST JOSEPH'S PREPARATORY SCHOOL",
    label: "St. Joseph's Preparatory School",
  },
  {
    value: 'ST KATHERINE SIENA SCHOOL',
    label: 'St. Katherine Siena School',
  },
  {
    value: 'ST LAURENTIUS SCHOOL',
    label: 'St. Laurentius School',
  },
  {
    value: 'ST MALACHY SCHOOL',
    label: 'St. Malachy School',
  },
  {
    value: 'ST MARTHA SCHOOL',
    label: 'St. Martha School',
  },
  {
    value: 'ST MARTIN DE PORRES SCHOOL',
    label: 'St. Martin de Porres School',
  },
  {
    value: 'ST MARTIN OF TOURS SCHOOL',
    label: 'St. Martin of Tours School',
  },
  {
    value: 'ST MARYS INTERPAROCHIAL SCHOOL',
    label: 'St. Marys Interparochial School',
  },
  {
    value: 'ST MATTHEW SCHOOL',
    label: 'St. Matthew School',
  },
  {
    value: 'ST MONICA SCHOOL (JUNIOR SCHOOL)',
    label: 'St. Monica School (Junior School)',
  },
  {
    value: 'ST MONICA SENIOR SCHOOL',
    label: 'St. Monica Senior School',
  },
  {
    value: 'ST PETER THE APOSTLE SCHOOL',
    label: 'St. Peter the Apostle School',
  },
  {
    value: 'ST PETERS SCHOOL',
    label: 'St. Peters School',
  },
  {
    value: 'ST PIO REGIONAL CATHOLIC SCHOOL',
    label: 'St. Pio Regional Catholic School',
  },
  {
    value: 'ST RAYMOND OF PENAFORT SCHOOL',
    label: 'St. Raymond of Penafort School',
  },
  {
    value: 'ST ROSE OF LIMA SCHOOL',
    label: 'St. Rose of Lima School',
  },
  {
    value: 'ST THOMAS AQUINAS SCHOOL',
    label: 'St. Thomas Aquinas School',
  },
  {
    value: 'ST VERONICA SCHOOL',
    label: 'St. Veronica School',
  },
  {
    value: 'STANTON, EDWIN M. SCHOOL',
    label: 'Stanton, Edwin M. School',
  },
  {
    value: 'STEARNE, ALLEN M. SCHOOL',
    label: 'Stearne, Allen M. School',
  },
  {
    value: 'STEEL, EDWARD SCHOOL',
    label: 'Steel, Edward School',
  },
  {
    value: 'STRAWBERRY MANSION HIGH SCHOOL',
    label: 'Strawberry Mansion High School',
  },
  {
    value: 'STUDENT TRANSITION CENTER',
    label: 'Student Transition Center',
  },
  {
    value: 'SULLIVAN, JAMES J. SCHOOL',
    label: 'Sullivan, James J. School',
  },
  {
    value: 'SWENSON ARTS/TECH HIGH SCHOOL',
    label: 'Swenson Arts/TECH High School',
  },
  {
    value: 'TACONY ACADEMY CHARTER SCHOOL',
    label: 'Tacony Academy Charter School',
  },
  {
    value: 'TAGGART, JOHN H. SCHOOL',
    label: 'Taggart, John H. School',
  },
  {
    value: 'TAYLOR, BAYARD SCHOOL',
    label: 'Taylor, Bayard School',
  },
  {
    value: 'TECH FREIRE CHARTER SCHOOL',
    label: 'TECH Freire Charter School',
  },
  {
    value: 'THE CITY SCHOOL',
    label: 'The City School',
  },
  {
    value: 'THE CITY SCHOOL AT SPRUCE HILL',
    label: 'The City School at Spruce Hill',
  },
  {
    value: 'THE LINC',
    label: 'The Linc',
  },
  {
    value: 'THE U SCHOOL',
    label: 'The U School',
  },
  {
    value: 'THE WORKSHOP SCHOOL',
    label: 'The Workshop School',
  },
  {
    value: 'TILDEN MIDDLE SCHOOL',
    label: 'Tilden Middle School',
  },
  {
    value: 'UNIVERSAL ALCORN CHARTER',
    label: 'Universal Alcorn Charter',
  },
  {
    value: 'UNIVERSAL AUDENRIED CHARTER',
    label: 'Universal Audenried Charter',
  },
  {
    value: 'UNIVERSAL CREIGHTON CHARTER',
    label: 'Universal Creighton Charter',
  },
  {
    value: 'UNIVERSAL INSTITUTE',
    label: 'Universal Institute',
  },
  {
    value: 'UNIVERSAL VARE CHARTER SCHOOL',
    label: 'Universal Vare Charter School',
  },
  {
    value: 'VARE-WASHINGTON ELEMENTARY',
    label: 'Vare-Washington Elementary',
  },
  {
    value: 'VAUX HIGH SCHOOL',
    label: 'Vaux High School',
  },
  {
    value: 'VISITATION SCHOOL',
    label: 'Visitation School',
  },
  {
    value: 'VOCATIO CAREER PREP HIGH SCHOOL',
    label: 'Vocatio Career Prep High School',
  },
  {
    value: 'WAGNER, GEN. LOUIS MIDDLE SCH.',
    label: 'Wagner, Gen. Louis Middle Sch.',
  },
  {
    value: 'WALDORF SCHOOL OF PHILADELPHIA',
    label: 'Waldorf School of Philadelphia',
  },
  {
    value: 'WARING, LAURA W. SCHOOL',
    label: 'Waring, Laura W. School',
  },
  {
    value: 'WASHINGTON, GEORGE HIGH SCHOOL',
    label: 'Washington, George High School',
  },
  {
    value: 'WASHINGTON, GROVER JR. MIDDLE',
    label: 'Washington, Grover Jr. Middle',
  },
  {
    value: 'WASHINGTON, MARTHA SCHOOL',
    label: 'Washington, Martha School',
  },
  {
    value: 'WEBSTER, JOHN H. SCHOOL',
    label: 'Webster, John H. School',
  },
  {
    value: 'WELSH, JOHN SCHOOL',
    label: 'Welsh, John School',
  },
  {
    value: 'WEST CATHOLIC PREPARATORY HIGH SCHOOL',
    label: 'West Catholic Preparatory High School',
  },
  {
    value: 'WEST OAK LANE CHARTER SCHOOL',
    label: 'West Oak Lane Charter School',
  },
  {
    value: 'WEST PHILADELPHIA ACHIEVEMENT',
    label: 'West Philadelphia Achievement',
  },
  {
    value: 'WEST PHILADELPHIA HIGH SCHOOL',
    label: 'West Philadelphia High School',
  },
  {
    value: 'WIDENER MEMORIAL SCHOOL',
    label: 'Widener Memorial School',
  },
  {
    value: 'WILLARD, FRANCES E. SCHOOL',
    label: 'Willard, Frances E. School',
  },
  {
    value: 'WILLIAM PENN CHARTER SCHOOL',
    label: 'William Penn Charter School',
  },
  {
    value: 'WISSAHICKON CHARTER SCHOOL',
    label: 'Wissahickon Charter School',
  },
  {
    value: 'WRIGHT, RICHARD R. SCHOOL',
    label: 'Wright, Richard R. School',
  },
  {
    value: 'YALE SCHOOL OF PHILADELPHIA',
    label: 'Yale School of Philadelphia',
  },
  {
    value: 'YES PHILLY',
    label: 'YES Philly',
  },
  {
    value: 'YESHIVA KETANA OF PHILADELPHIA',
    label: 'Yeshiva Ketana of Philadelphia',
  },
  {
    value: 'YOUNG SCHOLARS CHARTER SCHOOL',
    label: 'Young Scholars Charter School',
  },
  {
    value: 'YOUTHBUILD PHILADELPHIA CHARTER',
    label: 'Youthbuild Philadelphia Charter',
  },
  {
    value: 'ZHANG SAH MARTIAL ARTS & LEARNING CENTER',
    label: 'Zhang Sah Martial Arts & Learning Center',
  },
  {
    value: 'ZIEGLER, WILLIAM H. SCHOOL',
    label: 'Ziegler, William H. School',
  },
];
